module.exports = __webpack_public_path__ + "static/media/wells_fargo_logo.231c3532.png";